/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Dashboard_Stat_SalesInputs */

const en_seller_dashboard_stat_sales = /** @type {(inputs: Seller_Dashboard_Stat_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Sales`)
};

const es_seller_dashboard_stat_sales = /** @type {(inputs: Seller_Dashboard_Stat_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ventas totales`)
};

const fr_seller_dashboard_stat_sales = /** @type {(inputs: Seller_Dashboard_Stat_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ventes totales`)
};

const de_seller_dashboard_stat_sales = /** @type {(inputs: Seller_Dashboard_Stat_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkäufe gesamt`)
};

const ja_seller_dashboard_stat_sales = /** @type {(inputs: Seller_Dashboard_Stat_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`総売上`)
};

const zh_seller_dashboard_stat_sales = /** @type {(inputs: Seller_Dashboard_Stat_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总销量`)
};

const ar_seller_dashboard_stat_sales = /** @type {(inputs: Seller_Dashboard_Stat_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إجمالي المبيعات`)
};

const id_seller_dashboard_stat_sales = /** @type {(inputs: Seller_Dashboard_Stat_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Penjualan`)
};

const it_seller_dashboard_stat_sales = /** @type {(inputs: Seller_Dashboard_Stat_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendite Totali`)
};

const ru_seller_dashboard_stat_sales = /** @type {(inputs: Seller_Dashboard_Stat_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всего продаж`)
};

const pt_seller_dashboard_stat_sales = /** @type {(inputs: Seller_Dashboard_Stat_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de Vendas`)
};

const ko_seller_dashboard_stat_sales = /** @type {(inputs: Seller_Dashboard_Stat_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`총 판매량`)
};

/**
* | output |
* | --- |
* | "Total Sales" |
*
* @param {Seller_Dashboard_Stat_SalesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_dashboard_stat_sales = /** @type {((inputs?: Seller_Dashboard_Stat_SalesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Dashboard_Stat_SalesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_dashboard_stat_sales(inputs)
	if (locale === "es") return es_seller_dashboard_stat_sales(inputs)
	if (locale === "fr") return fr_seller_dashboard_stat_sales(inputs)
	if (locale === "de") return de_seller_dashboard_stat_sales(inputs)
	if (locale === "ja") return ja_seller_dashboard_stat_sales(inputs)
	if (locale === "zh") return zh_seller_dashboard_stat_sales(inputs)
	if (locale === "ar") return ar_seller_dashboard_stat_sales(inputs)
	if (locale === "id") return id_seller_dashboard_stat_sales(inputs)
	if (locale === "it") return it_seller_dashboard_stat_sales(inputs)
	if (locale === "ru") return ru_seller_dashboard_stat_sales(inputs)
	if (locale === "pt") return pt_seller_dashboard_stat_sales(inputs)
	return ko_seller_dashboard_stat_sales(inputs)
});